import { environment } from "../environments/environment.development";
import { httpService } from "./httpService";
import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";

class RoleService extends GenericService<ListItem, ListItem> {
    constructor() {
        super('/api/Roles');
    }

    // async getAllRoles(): Promise<ListItem[]> {
    //     return await httpService.get<ListItem[]>(`${environment.baseURL}/Roles/GetAllRoles`, undefined, {
    //         unwrap: true,
    //         normalize: true,
    //         toast: false,
    //     });
    // }
}

// const getAuthHeader = () => {
//     const token = localStorage.getItem('token');
//     return {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//     };
// }

// const getAllRoles = async (): Promise<string[]> => {
//     const response = await httpService.get<string[]>(`${environment.baseURL}/Roles/GetAllRoles`, getAuthHeader());
//     return response.data;
// }

// const roleService = {
//     getAllRoles,
// };

export const roleService = new RoleService();